require('./mod.filter');

function init() {
	if ($('.tab').length < 1) return;

	$('.tab').each(function() {
		var $tab = $(this);
		var $navItems = $tab.find('[data-toggle]');
		var $paneItems = $tab.find('.tab-pane');
		var $tabSelect = $tab.find('.tab-select select');

		$navItems.on('click', function(e) {
			e.preventDefault();
			var $paneItem = $($(this).attr('href'));

			$navItems.parent().removeClass('active');
			$(this).parent().addClass('active');

			$paneItems.removeClass('active fade-in');
			$paneItem.addClass('active');
			setTimeout(function() {
				$paneItem.addClass('fade-in');
			});
		});

		if($tabSelect.length >= 1){
			$tabSelect.change(function() {
				var $paneItem = $('#' + $(this).val());

				$paneItems.removeClass('active fade-in');
				$paneItem.addClass('active');
				setTimeout(function() {
					$paneItem.addClass('fade-in');
				});
			});
		}
	});
}

$(function() {
	init();
});